/**
 * AppRoutes.tsx
 * -------------
 * Defines all application routes using React Router.
 * - Maps paths to pages and handles 404s.
 */


import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from '../pages/LandingPage';
import CrashCourse from '../pages/CrashCourse/CrashCoursePage';
import GamifiedPath from '../pages/GamifiedPathPage';
import FinalTest from '../pages/FinalTestPage';
import Unlock from '../pages/UnlockPage';
import NotFound from '../pages/NotFoundPage';
import { PartTwoSlides } from '../components/CrashCourse/Modules/PartTwoSlides';
import { PartThreeSlides } from '../components/CrashCourse/Modules/PartThreeSlides';
import { PartFourSlides } from '../components/CrashCourse/Modules/PartFourSlides';
import { PartOneSlides } from '../components/CrashCourse/Modules/PartOneSlides';

const AppRoutes = () => (
  <Switch>
    <Route exact path="/" component={Landing} />
    <Route path="/crash-course" component={CrashCourse} />
    <Route path="/part-one" component={PartOneSlides} />
    <Route path="/part-two" component={PartTwoSlides} />
    <Route path="/part-three" component={PartThreeSlides} />
    <Route path="/part-four" component={PartFourSlides} />
    <Route path="/gamified-path" component={GamifiedPath} />
    <Route path="/final-test" component={FinalTest} />
    <Route path="/unlock" component={Unlock} />
    <Route path="/not-found" component={NotFound} />
    <Route component={NotFound} />
  </Switch>
);

export default AppRoutes;
